//@flow
import React from "react";
import { Grid, Typography, Stack, Box, Divider, useMediaQuery, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { LOANS } from "../../locales/namespaces";
import { textTranslate } from "../../../../helpers/helpers";
import useUserData from "../../../../hooks/user/useUserData";
import { NumericFormat } from "react-number-format";
import PermissionHOC from "../../../permission/components/permissionHOC/permissionHOC";
import { useTheme } from "@mui/material/styles";
import moment from "moment";
import Euro from "../../../../assets/images/icons/loan/euro";
import Bank from "../../../../assets/images/icons/loan/bank";
import Bullseye from "../../../../assets/images/icons/loan/bullseye";
import Copy from "../../../../assets/images/icons/loan/copy";
import Home from "../../../../assets/images/icons/loan/home";
import Check from "../../../../assets/images/icons/loan/check";
import Edit from "../../../../assets/images/icons/loan/edit";
import { ROUTE_PAGE_WIZARD } from "../../../../routers/routes";
import { ROUTE_LOAN_APPLICATION_CODE_ACCESS, ROUTE_LOAN_APPLICATION } from "../../../loanApplication/routes/routes";
import { Link } from "react-router-dom";
import { getRouteUrl } from "../../../../helpers/getRouteUrl";
import alphaLogo from '../../../../assets/images/banks/alphabank.jpg';
import ethnikiLogo from '../../../../assets/images/banks/ethniki.jpg';
import eurobankLogo from '../../../../assets/images/banks/eurobank.jpg';
import optimaLogo from '../../../../assets/images/banks/optima.jpg';
import piraeusLogo from '../../../../assets/images/banks/piraeus.jpg';
import atticabankLogo from '../../../../assets/images/banks/atticabank.png';
import pendingBank from '../../../../assets/images/banks/bank-image-pending.png';

import { logDOM } from "@testing-library/react";




const LoansDetails = ({ loanDetails }) => {
	const { t } = useTranslation(LOANS)
	const theme = useTheme();
	const { language, thousandSeparator, decimalSeparator } = useUserData()
	const matchBetweenXSMD = useMediaQuery(theme.breakpoints.between('xs', 'md'));



	const bankLogos = {
		alphabank: alphaLogo,
		ethniki: ethnikiLogo,
		eurobank: eurobankLogo,
		optima: optimaLogo,
		piraeus: piraeusLogo,
		attica: atticabankLogo,
	};

	const getBankLogoKey = (bankId) => {
		switch (bankId) {
			case '1':
				return 'ethniki';
			case '2':
				return 'eurobank'; 
			case '3':
				return 'alphabank'; 
			case '4':
				return 'piraeus';
			case '5':
				return 'optima'; 
			case '6':
				return 'attica';
			default:
				return null;
		}
	};


	const styles = {
		icon: {
			marginRight: '10px',
			lineHeight: 0
		},
	};

	return (
		<Box sx={{ py: 0 }} className="border-cnt-loans-details" sx={{'& p':{overflowWrap: 'anywhere'}}}>
			<Grid container spacing={3} style={{maxWidth:'1080px'}}>

				<Grid item xs={12} md={4}>
					<Stack spacing={0.5}>
						<Typography className="p-sm color-secondary flex-center-left">
							<Box sx={styles.icon}><Bank /></Box> {t('Bank')}
						</Typography>
						<Typography className="p-smx color-default">
							{(() => {
								const logoKey = getBankLogoKey(loanDetails.BankId);
								const logoSrc = bankLogos[logoKey];

								return logoSrc ? (
									<img
										src={logoSrc}
										alt={(loanDetails.BankId || '')}
										style={{ width: '128px', margin: '0 auto' }}
									/>
								) : (
									<span>
										<img src={pendingBank} alt='pendingBank' style={{ width: '128px', margin: '0 auto' }}/>
									</span>
								);
							})()}
						</Typography>
					</Stack>
				</Grid>

				<Grid item xs={12} md={4}>
					<Stack spacing={0.5}>
						<Typography className="p-sm color-secondary flex-center-left">
							<Box sx={styles.icon}><Bullseye /></Box> {t('Loan Purpose')}
						</Typography>
						<Typography className="p-smx color-default">
							{textTranslate(language)({
								en: loanDetails.TypeEn,
								el: loanDetails.TypeEl
							})}
						</Typography>
					</Stack>
				</Grid>

				<Grid item xs={12} md={4}>
					<Stack spacing={0.5}>

						<Typography className="p-sm color-secondary flex-center-left">
							<Box sx={styles.icon}><Copy /></Box> {t('Loan status')}
						</Typography>
						<Typography className="p-smx color-default">
							{textTranslate(language)({
								en: loanDetails.StatusEn,
								el: loanDetails.StatusEl
							})}
						</Typography>
					</Stack>
				</Grid>

				<Grid item xs={12} md={4}>
					<Stack spacing={0.5}>
						<Typography className="p-sm color-secondary flex-center-left">
							<Box sx={styles.icon}><Home /></Box> {t('Real Estate Value')}
						</Typography>
						<Typography className="p-smx color-default">
							<NumericFormat
								thousandSeparator={thousandSeparator}
								decimalSeparator={decimalSeparator}
								displayType="text"
								value={loanDetails.RealEstateValue ? loanDetails.RealEstateValue : '0'}
							/>
						</Typography>
					</Stack>
				</Grid>

				<Grid item xs={12} md={4}>
					<Stack spacing={0.5}>
						<Typography className="p-sm color-secondary flex-center-left">
							<Box sx={styles.icon}><Euro /></Box> {t('Loan Amount (€)')}
						</Typography>
						<Typography className="p-smx color-default">
							<NumericFormat
								thousandSeparator={thousandSeparator}
								decimalSeparator={decimalSeparator}
								displayType="text"
								value={loanDetails.RequestedAmount ? loanDetails.RequestedAmount : '-'}
							/>
						</Typography>
					</Stack>
				</Grid>

				<Grid item xs={12} md={4}>
					<Stack spacing={0.5}>
						<Typography className="p-sm color-secondary flex-center-left">
							<Box sx={styles.icon}><Check /></Box> {t('Created')}
						</Typography>
						<Typography className="p-smx color-default">
							{moment(loanDetails.CreatedAt).format("DD-MM-YYYY")}
						</Typography>
					</Stack>
				</Grid>

			</Grid>

			<Divider sx={{ margin: '32px 0', borderColor: '#DAE0F0', borderBottom: "0.6px solid #DAE0F0"}} />

			<Grid container spacing={{xs: 3, sm: 3,  md: 6, lg: 6, xl: 6}} style={{maxWidth:'680px'}}>

				<Grid item xs={12} md={6}>
					<Stack spacing={0.5}>
						<Typography className="p-sm color-secondary flex-center-left">
							{t('Loan Duration')}
						</Typography>
						<Typography className="p-smx color-default">
							{loanDetails.Duration ? loanDetails.Duration : '-'}
						</Typography>
					</Stack>
				</Grid>

				<Grid item xs={12} md={6}>
					<Stack spacing={0.5}>
						<Typography className="p-sm color-secondary flex-center-left">
							{t('Fixed Interest Rate Duration')}
						</Typography>
						<Typography className="p-smx color-default">
							{loanDetails.FixedDuration ? loanDetails.FixedDuration : '-'}
						</Typography>
					</Stack>
				</Grid>

				<Grid item xs={12} md={6}>
					<Stack spacing={0.5}>
						<Typography className="p-sm color-secondary flex-center-left">
							{t('Number of Borrowers')}
						</Typography>
						<Typography className="p-smx color-default">
							{loanDetails.CoborrowerNo ? loanDetails.CoborrowerNo : '-'}
						</Typography>
					</Stack>
				</Grid>

				<Grid item xs={12} md={6}>
					<Stack spacing={0.5}>
						<Typography className="p-sm color-secondary flex-center-left">
							{t('Number of Guarantors')}
						</Typography>
						<Typography className="p-smx color-default">
							{loanDetails.GuarantorNo ? loanDetails.GuarantorNo : '-'}
						</Typography>
					</Stack>
				</Grid>

				<PermissionHOC requiredPermissions={['view_loan_cust_name']}>
					<Grid item xs={12} md={6}>
						<Stack spacing={0.5}>
							<Typography className="p-sm color-secondary flex-center-left">
								{t('Name')}
							</Typography>
							<Typography className="p-smx color-default">
								{loanDetails.CustName}
							</Typography>
						</Stack>
					</Grid>
				</PermissionHOC>

				<PermissionHOC requiredPermissions={['view_loan_email']}>
					<Grid item xs={12} md={6}>
						<Stack spacing={0.5}>
							<Typography className="p-sm color-secondary flex-center-left">
								{t('Email')}
							</Typography>
							<Typography className="p-smx color-default">
								{loanDetails.email}
							</Typography>
						</Stack>
					</Grid>
				</PermissionHOC>

				<PermissionHOC requiredPermissions={['view_loan_phone']}>
					<Grid item xs={12} md={6}>
						<Stack spacing={0.5}>
							<Typography className="p-sm color-secondary flex-center-left">
								{t('Phone')}
							</Typography>
							<Typography className="p-smx color-default">
								{loanDetails.MobilePhone}
							</Typography>
						</Stack>
					</Grid>
				</PermissionHOC>

				<PermissionHOC requiredPermissions={['view_loan_origin']}>
					<Grid item xs={12} md={6}>
						<Stack spacing={0.5}>
							<Typography className="p-sm color-secondary flex-center-left">
								{t('Loan Origin')}
							</Typography>
							<Typography className="p-smx color-default">
								{textTranslate(language)({
									en: loanDetails.OriginEn,
									el: loanDetails.OriginEl
								})}
							</Typography>
						</Stack>
					</Grid>
				</PermissionHOC>

				{/* {loanDetails.PartnerName && (
					<Grid item xs={12} md={6}>
						<Stack spacing={0.5}>
							<Typography className="p-sm color-secondary flex-center-left">
								{t('Recommended by')}
							</Typography>
							<Typography className="p-smx color-default">
								{loanDetails.PartnerName}
							</Typography>
						</Stack>
					</Grid>
				)} */}

				<PermissionHOC requiredPermissions={['view_loan_comments']}>
					<Grid item xs={12} md={12}>
						<Stack spacing={0.5}>
							<Typography className="p-sm color-secondary flex-center-left">
								{t('Comments')}
							</Typography>
							<Typography className="p-smx color-default">
								{loanDetails.Comments}
							</Typography>
						</Stack>
					</Grid>
				</PermissionHOC>

				<Grid item xs={12} md={12}>
					{loanDetails.AccessApp === '1' && (
						<Button
							size={"small"}
							variant={"contained"}
							color={'info'}
							sx={{ textAlign: 'center', marginTop: {xs:'5px',sm:'5px', md:'24px'} }}
							component={Link}
							to={getRouteUrl(ROUTE_LOAN_APPLICATION, { id: loanDetails.id })}
						>
							<Edit />  <span style={{ marginLeft: '10px' }}> {t('Application Details Completion')} </span>
						</Button>
					)}
				</Grid>

			</Grid>
		</Box>
	)
}

export default LoansDetails;
